import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import logoImg from '@/assets/logo.png';

interface LogoProps {
  size?: number | string; // Optional fixed size
  showText?: boolean;
  className?: string; // Classes for the container
  imageClassName?: string; // Classes for the image (useful for responsive sizes)
  textClassName?: string; // Classes for the text container
  variant?: 'default' | 'light';
}

const Logo: React.FC<LogoProps> = ({
  size,
  showText = true,
  className,
  imageClassName,
  textClassName,
  variant = 'default'
}) => {
  const isLight = variant === 'light';

  return (
    <Link to="/" className={cn("flex items-center gap-3 group", className)}>
      <img
        src={logoImg}
        alt="Ratchagan Analysis Logo"
        className={cn(
          "object-contain transition-transform group-hover:scale-105",
          imageClassName
        )}
        style={size ? { width: size, height: size } : undefined}
      />
      {showText && (
        <div className={cn("leading-tight flex flex-col", textClassName)}>
          <div className={cn(
            "transition-colors",
            isLight
              ? "text-[16px] md:text-[18px] font-bold text-white opacity-100"
              : "text-lg font-bold text-primary"
          )}>
            Ratchagan
          </div>
          <div className={cn(
            "text-sm font-semibold transition-colors",
            isLight ? "text-white/80" : "text-muted-foreground/80"
          )}>
            Analysis
          </div>
        </div>
      )}
    </Link>
  );
};

export default Logo;
